import { Alert, Box, Typography } from '@mui/material'

import type { FailedPage } from '@/models/Orgs'
import { FAILED_PAGE_FALLBACK, formatWebsiteUploadError } from '@/utils/websiteUploadErrors'

/**
 * What a website crawl couldn't store: each failed page with the message a
 * single upload of it would show, then any other warnings.
 */
export default function CrawlPageIssues({
  failedPages = [],
  warnings = [],
}: {
  failedPages?: FailedPage[]
  warnings?: string[]
}) {
  return (
    <>
      {failedPages.length > 0 && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
            {failedPages.length === 1
              ? 'We couldn’t read this page:'
              : 'We couldn’t read these pages:'}
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2 }}>
            {failedPages.map((page) => (
              <li key={page.website}>
                <Typography variant="body2">
                  {page.website}: {formatWebsiteUploadError(page.error, FAILED_PAGE_FALLBACK)}
                </Typography>
              </li>
            ))}
          </Box>
        </Alert>
      )}
      {warnings.length > 0 && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
            Some pages were skipped:
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2 }}>
            {warnings.map((warning, index) => (
              <li key={index}>
                <Typography variant="body2">{warning}</Typography>
              </li>
            ))}
          </Box>
        </Alert>
      )}
    </>
  )
}
